var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MultipleChoicesDropdown',{attrs:{"title":"Country","value":_vm.startup.country,"show-clear-all":false,"single-choice":true,"search-enabled":true,"choices":_vm.countriesChoices},on:{"change":function($event){return _vm.onChange($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }